import React from 'react';

import TimsForGood from '@rbilabs/tims-for-good';

import { useLocale } from 'state/intl';
import { useMParticleContext } from 'state/mParticle';

export default () => {
  const { language } = useLocale();
  const mParticle = useMParticleContext();

  return (
    <TimsForGood
      lang={language}
      mParticle={mParticle.logEvent}
      offSets={[
        { minWidth: 0, offSetTop: 56 },
        { minWidth: 813, offSetTop: 78 },
      ]}
    />
  );
};
